module.exports = __webpack_public_path__ + "static/pi2-231ee85bad87b63d6cfda18e99075f17.png";